import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { TwelveMonthExpenseInsightsEntity } from "../entities/TwelveMonthExpenseInsightsEntity";

export class GetTwelveMonthExpenseInsightsUseCase {
  constructor(private repository: ClientOverviewRepository) {}

  async execute(): Promise<TwelveMonthExpenseInsightsEntity> {
    return this.repository.getTwelveMonthExpenseInsights();
  }
}
